export default class Cookie {
  static set(name, value = '', days = 0) {
    let date = new Date()
    date.setDate(date.getDate() + days)
    const expires = days ? date.toUTCString() : ''
    document.cookie = name + '=' + value.toString() + '; expires=' + expires + '; path=/;'
  }

  static get(name) {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(name+'='))
      ?.split("=")[1]
  }

  static erase(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  }

  static clear() {
    var cookies = document.cookie.split(";")

    cookies.forEach(c => {
      var pos = c.indexOf("=");
      var name = pos > -1 ? c.substr(0, pos) : c
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC"
    })
  }
}